export default __webpack_public_path__ + "static/media/SignupPage.c5ad9f88.jpeg";